import React from 'react'
import styled from 'styled-components'
import {
  compose, space, color, typography
} from 'styled-system'
import { texts } from '@zuto/utilities'
import { TextProps } from './text-utils'

export type LabelVariants = 'label' | 'experimental'

interface FormLabelProps extends React.InputHTMLAttributes<HTMLLabelElement> {
  name: string,
  labelVariant?: LabelVariants
}

const StyledFormLabel = styled.label<React.InputHTMLAttributes<HTMLLabelElement> & TextProps>`
  ${texts}
  ${compose(space, color, typography)}
`

const FormLabel = ({
  children, name, labelVariant = 'label', ...props
}: FormLabelProps) => (
  <StyledFormLabel id={`label-${name}`} htmlFor={name} {...props} $variant={labelVariant}>
    {children}
  </StyledFormLabel>
)

export default FormLabel
